import { defineStore } from 'pinia'

export const useCache = defineStore('cache', {
  state() {
    return {
      natureType: [],
      financialInstitutions: [],
      countriesBanks: [],
      banks: [],
      maintenanceEnabled: false,
      debuggerEnabled: false
    }
  },

  getters: {
    getNatureType() {
      return this.natureType
    },
    getFinancialInstitutions() {
      return this.financialInstitutions
    },
    getCountriesBanks() {
      return this.countriesBanks
    },
    getBanks() {
      return this.banks
    },
    getMaintenanceEnabled() {
      return this.maintenanceEnabled
    }
  },
  persist: true
})
